import { render, staticRenderFns } from "./MusicItem.vue?vue&type=template&id=1003de40&scoped=true"
import script from "./MusicItem.vue?vue&type=script&lang=js"
export * from "./MusicItem.vue?vue&type=script&lang=js"
import style0 from "./MusicItem.vue?vue&type=style&index=0&id=1003de40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1003de40",
  null
  
)

export default component.exports